import styled from 'styled-components';

import { NestedRoutingProps } from './nested.routing';


type HeaderLayoutpProps = {} & Pick<NestedRoutingProps, 'appearance'>;

const Root = styled.div`
	flex: 1 1 auto;
	position: relative;
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
`;

const HeaderLayout = styled.div`
	flex: 0 0 auto;
	position: relative;
	width: 100%;
	height: auto;
	min-height: 56px;
	background-color: #fff;
	padding: 0 40px;
	display: flex;
	align-items: flex-end;

	${(p: HeaderLayoutpProps) => p.appearance === 'transparent' && `
		background-color: transparent;
	`}
`;

const ContentLayout = styled.div`
	width: 100%;
	flex: 1 1 auto;
`;

export {
	Root,
	HeaderLayout,
	ContentLayout,
};
